import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Select, Tooltip } from 'antd';
import './style.scss';
import { InfoCircleOutlined } from '@ant-design/icons';
import PRZSelect from '../../UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
function TenantSelector({
  loading, onChange, disabled, showError, title, hideTitle, containerClassName, inputClassName, labelClassName,
  user, customStyle, selectedTenant, placeholder, showAll, includedTenants, isMultiple, noDropdownAlign, showSearch, bordered, disabledOptions = [], enableToolTip, toolTipMessage,allowClear
}) {
  return (
    <div className={`tenant-selector__wrapper ${containerClassName}`}>
      {!hideTitle ? (
        <label className={labelClassName || 'orgFormLabel'}>
          {title || 'Business Unit'}
          <span style={{ color: 'red' }}>{'  *'}</span>
          {enableToolTip && toolTipMessage && (
            <Tooltip title={toolTipMessage}>
              <InfoCircleOutlined
                style={{
                  marginLeft: '5px',
                  color: 'grey',
                  cursor: 'pointer',
                }}
              />
            </Tooltip>
          )}
        </label>
      ) : <React.Fragment /> }
      {/* <Select
        mode={isMultiple ? 'multiple' : ''}
        value={selectedTenant}
        filterOption={false}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(value) => onChange(value === 'All' ? 'All' : value)}
        style={customStyle || {
          border: '1px solid rgba(68, 130, 218, 0.2)',
          minHeight: '32px',
        }}
        className={inputClassName || ' input'}
        dropdownAlign={!noDropdownAlign && { offset: [-4, 4] }}
        bordered={bordered || false}
        showSearch={showSearch}
        loading={loading}
        maxTagCount="responsive"
        allowClear={allowClear}
      >
        {(showAll && !isMultiple) && (
          <Option key="All" value="All">
            All Business Unit
          </Option>
        ) }
        {includedTenants ? user?.user_tenants?.filter((tenant) => includedTenants?.includes(tenant?.tenant_id))?.map((tenant) => (
          <Option key={tenant?.tenant_id} value={tenant?.tenant_id}>
            {tenant?.tenant_name}
          </Option>
        )) : user?.user_tenants?.map((tenant) => (
          <Option key={tenant?.tenant_id} value={tenant?.tenant_id} disabled={disabledOptions.includes(tenant?.tenant_id)}>
            {tenant?.tenant_name}
          </Option>
        )) }
      </Select> */}
      <PRZSelect
        mode={isMultiple ? 'multiple' : 'default'}
        value={selectedTenant}
        filterOption={false}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(value) => onChange(value === 'All' ? 'All' : value)}
        style={customStyle}
        className={inputClassName || ' input'}
        dropdownAlign={!noDropdownAlign && { offset: [-4, 4] }}
        bordered={bordered || true}
        showSearch={showSearch}
        loading={loading}
        maxTagCount="responsive"
      >
        {(showAll && !isMultiple) && (
          <Option key="All" value="All">
            All Business Unit
          </Option>
        )}
        {includedTenants ? user?.user_tenants?.filter((tenant) => includedTenants?.includes(tenant?.tenant_id))?.map((tenant) => (
          <Option key={tenant?.tenant_id} value={tenant?.tenant_id}>
            {tenant?.tenant_name}
          </Option>
        )) : user?.user_tenants?.map((tenant) => (
          <Option key={tenant?.tenant_id} value={tenant?.tenant_id} disabled={disabledOptions.includes(tenant?.tenant_id)}>
            {tenant?.tenant_name}
          </Option>
        ))}
      </PRZSelect>
      {showError && (
        <div className="input-error">
          *Please select location
        </div>
      )}
    </div>

  );
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
});

const mapDispatchToProps = () => ({

});

TenantSelector.propTypes = {
  user: PropTypes.any,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  showError: PropTypes.bool,
  title: PropTypes.any,
  hideTitle: PropTypes.bool,
  containerClassName: PropTypes.any,
  placeholder: PropTypes.string,
  inputClassName: PropTypes.any,
  labelClassName: PropTypes.string,
  customStyle: PropTypes.any,
  selectedTenant: PropTypes.any,
  showAll: PropTypes.bool,
  includedTenants: PropTypes.any,
  isMultiple: PropTypes.bool,
  noDropdownAlign: PropTypes.any,
  showSearch: PropTypes.bool,
  disabledOptions: PropTypes.array,
  enableToolTip: PropTypes.bool,
  toolTipMessage: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TenantSelector));
